import { Injectable, EventEmitter } from '@angular/core';
import { LanguageService } from './language.service';
import { AlertData } from '../alert/alert-data.entity';
import { NewProjectData } from '../entities/new-project.entity';
import { ProjectData } from '../entities/project-data.entity';
import { UserService } from './user.service';


@Injectable({
	providedIn: 'root'
})
export class ModelService {

	public GProjectLoadScheme: EventEmitter<string> = new EventEmitter();

	public saveProjectSignal: EventEmitter<any> = new EventEmitter();
	public alertSignal: EventEmitter<AlertData> = new EventEmitter();
	public alertResultSignal: EventEmitter<boolean> = new EventEmitter();
	public resetSignal: EventEmitter<ProjectData> = new EventEmitter();
	public resetSignalCanvas: EventEmitter<ProjectData> = new EventEmitter();
	public logoutSignal: EventEmitter<boolean> = new EventEmitter();

	public sendForAprovalSatelite: EventEmitter<any> = new EventEmitter();
	public sendForAprovalSqueme: EventEmitter<any> = new EventEmitter();

	public squemaGoToHomeSignal: EventEmitter<boolean> = new EventEmitter();

	// Menú en los editores, fue eliminado.
	//public closeMenuContextEditors: EventEmitter<any> = new EventEmitter();

	public showDataUser: EventEmitter<string> = new EventEmitter();

	public newProjectSignal: EventEmitter<NewProjectData> = new EventEmitter();
	public newProjectResultSignal: EventEmitter<NewProjectData> = new EventEmitter();

	constructor(
		public languageService: LanguageService,
		private userService: UserService) { }

	public getLanguage(): LanguageService { return this.languageService; }

	public getUser(): UserService { return this.userService; }

	public getString(value: string): string {
		return (this.languageService) ? this.languageService.getTranslation(value) : '';
	}

	public saveLanguageRemote() {
		this.languageService.saveRemote(this.userService.getData().id);
	}

	private saveLocal(key: string, value: any): void {
		localStorage.setItem(key, value);
	}
}
